import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default function Item(props) {
  const [acOpen, setAcOpen] = useState(false);

  return (
      <div className="purchase_row">
        <div
          className="purchase_acr_title" style={{cursor: 'pointer'}}
          onClick={() => setAcOpen(!acOpen)}
        >
          <Row>
            <Col xs="8">
              <h3>
                {" "}
                <FontAwesomeIcon
                  icon={acOpen ? faChevronUp : faChevronDown}
                />{" "}
                {props.itemname}
              </h3>
              <p>
                Pack Quantity: <strong>{props.packqty || "N/A"}</strong>
              </p>
              <p>
                Loose Quantity: <strong>{props.quantity || props.qty || 0}</strong>
              </p>
            </Col>
            <Col xs="4">
              <strong>₹ {(props.price && props.quantity) ? (parseFloat(props.price) * parseFloat(props.quantity)).toFixed(2) : (props.dettotal ? parseFloat(props.dettotal).toFixed(2) : "0.00")}</strong>
            </Col>
          </Row>
        </div>
        {acOpen && (
            <div className="purchase_acr_detail">
              <p>
                Batch no: <strong>{props.batchno || "N/A"}</strong>
              </p>
              <p>
                Expiry date: <strong>{props.expdate || "N/A"}</strong>
              </p>
              <p>
                MRP: <strong>₹{props.mrp ? parseFloat(props.mrp).toFixed(2) : (props.price ? parseFloat(props.price).toFixed(2) : "0.00")}</strong>
              </p>
            </div>
        )}
      </div>
  );
}
